import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-4" data-id="element-71" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border border-golf-line bg-golf-light p-3.5 shadow-sm" data-id="element-72" data-mp="1o33s8bhenif4">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-golf-gold" aria-hidden="true" data-id="element-73" data-mp="221249a8972rg" />
        <div data-id="element-74" data-mp="1x28vtw7tq1y5">
          <h2 className="mb-0.5 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-75" data-mp="19eqx1gq563lo">
            Your Purchase Is 100% Protected
          </h2>
          <p className="text-xs font-medium leading-snug text-golf-muted sm:text-base" data-id="element-76" data-mp="14dl3xhskkebm">
            Try GOLF COACH PRO™ for 14 full days. Explore the sessions, drills, assessments,
            practice plans, tracking tools, and bonuses. If you decide it isn't right for you,
            contact us within 14 days for a full refund.{' '}
            <span className="font-bold text-golf-green" data-id="element-77" data-mp="lpohqfizcmuc">Zero risk.</span>
          </p>
        </div>
      </div>
    </section>;
}